import { User } from './user';

export class AuthState {

    static readonly INITIAL = 'initial';
    static readonly SIGN_IN = 'signIn';
    static readonly CONFIRM_SIGN_IN = 'confirmSignIn';
    static readonly REQUIRE_NEW_PASSWORD = 'requireNewPassword';
    static readonly SIGNED_IN = 'signedIn';

    static readonly SIGNED_OUT = 'signedOut';

    static readonly SIGN_UP = 'signUp';
    static readonly CONFIRM_SIGN_UP = 'confirmSignUp';
    static readonly SIGNED_UP = 'signedUp';

    static readonly FORGOT_PASSWORD = 'forgotPassword';

    state: string;
    user: User;
}
